import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";

// Shared renderer for item descriptions — limited markdown, light styling
export default function MarkdownDescription({ children }) {
  return (
    <ReactMarkdown
      rehypePlugins={[
        [
          rehypeSanitize,
          {
            tagNames: ["p", "a", "strong", "em", "br"],
            attributes: { a: ["href", "target", "rel"] },
          },
        ],
      ]}
      components={{
        p: ({ children }) => (
          <p className="font-serif text-base leading-relaxed mb-4 text-ink/80">
            {children}
          </p>
        ),
        a: ({ href, children }) => (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-seal underline underline-offset-2 hover:text-seal-deep"
          >
            {children}
          </a>
        ),
        strong: ({ children }) => (
          <strong className="font-semibold text-ink">{children}</strong>
        ),
        em: ({ children }) => <em className="italic text-ink">{children}</em>,
      }}
    >
      {children}
    </ReactMarkdown>
  );
}
